import { BaseModel } from './base-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';
import BlockModel from './block-model.interface';

export interface MomentsModel extends BaseModel {
  variables?: { [key: string]: string } | MomentsVariables;
}

export interface MomentsVariables {
  MomentsImageDesktop: string;
  MomentsImageMobile: string;
  MomentsHref: string;
  MomentsAlt: string;
  MomentsHrefSegmentRegex: string;
}

export class MomentsInitVariables implements MomentsVariables {
  MomentsImageDesktop = '';
  MomentsImageMobile = '';
  MomentsHref = '';
  MomentsAlt = '';
  MomentsHrefSegmentRegex = '';
}

export class MomentsInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new MomentsInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
